import { msg } from "@lingui/core/macro";

export const maxSelfServiceVehicleChangesRuleMessages = {
	name: msg({ message: "Maximum Self-Service Vehicle Changes" }),
	description: msg({ message: "The maximum number of times a parker can add or change vehicles on a permit" }),
	errors: {
		limitReached: msg({
			message:
				"This permit has used all {maxSelfServiceChanges} of its self-service vehicle changes. Contact your parking administrator to update vehicles.",
		}),
	},
} as const;
